export default __webpack_public_path__ + "static/media/pixel-small-logo.829d1c50.png";